/* eslint-disable no-restricted-globals */
// JS Base
import '../js/index';

// Base SCSS
import '../scss/base.scss';

import '../scss/pricing.scss';

$(() => {
  const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1
               && navigator.userAgent
               && navigator.userAgent.indexOf('CriOS') === -1
               && navigator.userAgent.indexOf('FxiOS') === -1;

  if (isSafari) {
    $('.d-safari-none').addClass('d-none');
    $('.d-safari').addClass('d-block');
  }
});
